import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';

const actionLogger = (store) => (next) => (action) => {
  console.log("📦 REDUX ACTION:", action.type, action.payload);
  const result = next(action);
  console.log("📋 STATE AFTER ACTION:", store.getState().auth);
  window.__REDUX_STATE__ = store.getState();
  return result;
};

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(actionLogger),
});

window.__REDUX_STORE__ = store;